import React, { Component } from 'react';
import {List, InputItem, Switch, WingBlank, Button,WhiteSpace,Toast} from 'antd-mobile';
import send from '../../../utils/send';
export default class BatchEdit extends Component {
  constructor (props) {
    super(props);
    this.state = {
      activeFlg: 'Y'
    }
  }
  componentWillUnmount() {
    this.setState = () => false
  }
  componentDidMount() {
    console.log(this.props.location.state);
    const propsState = this.props.location.state;
    this.setState({
      ...propsState
    })
  }
  doSave = () => {
    send({
      url: '/api/forward/ifarm/simpleFarmHouse/updateFarmOrg',
      method: 'post',
      data: {
        activeFlg: this.state.activeFlg,
        farmOrg: this.state.farmOrg,
        farmOrgName: this.state.farmOrgName
      }
    }).then(res => {
      if(res.data.statusCode === '200') {
        Toast.info('保存成功', 1,() => {
          this.props.history.push('/batch_list')
        })
      } else {
        Toast.info('更新失败:' + res.data.msg)
      }
    })
  };
 render() {
    const {farmOrgName,activeFlg} = this.state;
  return (
    <React.Fragment>
      <List>
        <InputItem
            maxLength={20}
            type={'text'}
            className={'text-right'}
            placeholder={farmOrgName || '请输入'}
            onChange={v => {
            this.setState({
              farmOrgName: v
            })
          }}
        >
          批次名称
        </InputItem>
        <List.Item extra={<Switch checked={activeFlg==='Y'}
            onChange={() => {
              const flag = (activeFlg === 'Y') ? 'N':'Y';
                                    this.setState({
                                      activeFlg: flag
                                    });
                                  }}
                          />}
        >
          批次状态
        </List.Item>
      </List>

      <WingBlank size="lg">
        <WhiteSpace size={'lg'} />
        <Button type={'primary'}
            onClick={this.doSave}
        >完成</Button>
      </WingBlank>
    </React.Fragment>
  )
 }
}
